/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBoxLogo = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2.8 7c-.45 0-.8.324-.8.694v5.827c.021.93.436 1.815 1.155 2.464a3.99 3.99 0 0 0 2.69 1.005c.704 0 1.396-.177 2.003-.51s1.104-.813 1.442-1.386c.65 1.11 1.948 1.896 3.395 1.896 2.147 0 3.895-1.572 3.895-3.56.05-1.897-1.698-3.47-3.844-3.47-1.448 0-2.746.74-3.395 1.85-.65-1.11-1.949-1.85-3.446-1.85-.9 0-1.698.277-2.348.693V7.694a.686.686 0 0 0-.224-.486A.797.797 0 0 0 2.8 7zm13.868 2.885a.842.842 0 0 0-.586.122c-.3.231-.4.694-.15 1.017l1.997 2.405-1.997 2.405c-.25.324-.2.74.15.973.35.231.847.23 1.097-.095l1.7-2.035 1.746 2.082c.25.278.75.324 1.098.093.3-.232.35-.648.101-.972l-1.948-2.404 1.948-2.36c.25-.323.248-.786-.1-1.017-.4-.232-.85-.186-1.1.138l-1.746 1.989-1.7-2.08a.855.855 0 0 0-.51-.261zM5.844 11.347c1.298 0 2.348.972 2.348 2.129 0 1.202-1.05 2.127-2.348 2.127s-2.347-.925-2.347-2.127c0-1.157 1.049-2.13 2.347-2.13zm6.892 0c1.298 0 2.346.972 2.346 2.129-.05 1.202-1.098 2.127-2.346 2.127-1.299 0-2.348-.925-2.348-2.127 0-1.157 1.05-2.13 2.348-2.13z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBoxLogo as BoxLogo };
